import React, { useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import classnames from "classnames";
import { TaskContext } from "contexts/task";
import { useQaNavActions } from "shared/hooks/use-qa-nav-actions";
import { ValidationModal } from "./components/validation-modal";

const QANav = (props) => {
    const { task } = useContext(TaskContext);
    const { isBusy, finishTask, rejectQa, validation } = useQaNavActions({ ...props, task });
    const completeIcon = props.acceptPayload && props.acceptPayload.icon ? props.acceptPayload.icon : faCheck;
    const completeTitle = props.acceptPayload && props.acceptPayload.label ? props.acceptPayload.label : props.isQA ? "Accept Task" : "Complete Task";

    return (
        <>
            <ValidationModal validation={validation} finishTask={finishTask} />
            <div className="task-nav">
                <div className="button-group -right">
                    {props.isQA && !props.hideReject && (
                        <button
                            className={classnames("button -error", { "-disabled": isBusy || props.isDirty || props.isReadOnlyReject })}
                            onClick={rejectQa}
                            title="Reject Task"
                            disabled={isBusy || props.isReadOnlyReject}
                        >
                            <FontAwesomeIcon icon={faTimes} />
                        </button>
                    )}
                    <button
                        className={classnames("button -primary", { "-disabled": isBusy || props.isDirty || props.isReadOnly })}
                        onClick={() => finishTask()}
                        title={completeTitle}
                        disabled={isBusy || props.isReadOnly || props.hasRedo}
                    >
                        <FontAwesomeIcon icon={completeIcon} />
                    </button>
                </div>
            </div>
        </>
    );
};

export default QANav;
